export enum Lob {
  CarInsurance = 'car-insurance',
  LifeInsurance = 'life-insurance',
  HomeInsurance = 'home-insurance',
  TravelInsurance = 'travel-insurance'
}